<style lang="stylus" scope>
    .topbar-menubox
        position relative
        z-index 1
        .menubox-menu
            display flex
            position absolute
            list-style none
            --tLeft 0
            --tWidth 0
            &::after
                content ''
                position absolute
                height 100%
                width calc(var(--tWidth, 0) * 1px)
                left calc(var(--tLeft, 0) * 1px)
                border-bottom 2px solid var(--themeColor)
                transition left .2s linear, width .2s linear
            li
                position relative
                max-width 130px
                height 28px
                color #000
                font-size 14px
                text-align center
                line-height 18px
                cursor pointer
                &:not(:last-child)
                    margin-right 32px
                p
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                &:hover
                    >p
                        color var(--themeColor)
                &.active
                    >p
                        color var(--themeColor)
                        font-weight 700
</style>

<template>
    <div class="topbar-menubox" ref="menuItem">
        <ul ref="menu" class="menubox-menu">
            <li :class="{ active: value == item.id }" v-for="item in menuList" :key="item.id" @click="clickMenu($event, item.id)">
                <p>{{ item.label }}</p>
            </li>
        </ul>
    </div>
</template>

<script lang="ts">
    import { refreshToken } from "@/public/utils/auth";
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    @Component({
        components: {},
    })
    export default class Menu extends Vue {
        @Prop()
        menuList;
        @Prop()
        value;
        @Prop({
            default: 0,
        })
        defaultId;
        menuIndex = 0;

        clickMenu(e, id) {
            for (let i = 0; i < this.menuList.length; i++) {
                if (this.menuList[i]["id"] == id) {
                    this.menuIndex = i;
                    break;
                }
            }
            this.$emit("toMenu");
            this.toMenu(this.menuIndex);
        }
        toMenu(index) {
            this.menuIndex = index;
            this.$nextTick(() => {
                this.setUnderLine(index);
            });
            this.$emit("input", this.menuList[this.menuIndex]["id"]);
        }
        setUnderLine(index) {
            let pDom = this.$refs.menu as any;
            if (!pDom) return;
            let w = pDom.children[index].getBoundingClientRect()["width"];
            let l = pDom.children[index].getBoundingClientRect()["x"] - pDom.getBoundingClientRect()["x"];
            pDom.style.setProperty("--tLeft", "" + l);
            pDom.style.setProperty("--tWidth", "" + w);
        }
        //生命周期
        observer = null;
        mounted() {
            this.$nextTick(() => {
                if (this.menuList.length > 0) {
                    this.toMenu(this.value);
                }
            });
            this.observer = new (window as any).ResizeObserver((entries) => {
                if (entries[0] && entries[0].contentRect.height !== 0) {
                    setTimeout(() => {
                        this.setUnderLine(this.value);
                    }, 0);
                }
            });
            this.observer.observe(this.$refs.menuItem as any);
        }
        @Watch("lang")
        watchLang(nv, ov) {
            if (nv) {
                this.$nextTick(() => {
                    this.setUnderLine(this.menuIndex);
                });
            }
        }

        created() {}
        beforeDestroy() {
            this.observer?.unobserve(this.$refs.menuItem as any);
            this.observer = null;
        }
    }
</script>
